import { FolderOutlined, GitHub } from "@material-ui/icons";
import React from "react";
import { Card } from "react-bootstrap";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import "../css/App.css";

export default function ProjectCard({ data }) {
  return (
    <div id="pCard" className="col-10 col-lg-4 col-md-6 col-sm-6 ">
      <Card
        id="projectCard"
        style={{
          position: "relative",
          color: "white",
          borderRadius: "5px",
          height: "20rem",
        }}
        className='my-2'
      >
        <div className="d-flex flex-grow-1 mt-4 mx-3">
          <FolderOutlined style={{ color: "white" }} />
          <div style={{ marginLeft: "auto" }}>
            <GitHub
              className="mx-1"
              onClick={() => {
                window.open(data.github, "");
              }}
            />
            <OpenInNewIcon className="mx-1" 
             onClick={() => {
              window.open(data.live, "");
            }}/>
          </div>
        </div>
        <Card.Body id="cardText" className="mt-0">
          <Card.Title> {data.heading} </Card.Title>
          <Card.Text>{data.content}</Card.Text>
          <Card.Text
            style={{
              fontSize: "small",
              position: "absolute",
              left: "5%",
              bottom: "5%",
            }}
          >
            {data.techs}
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
}
